import { lazy, Suspense } from "react";
import { Switch, Route } from "react-router-dom";
import Footer from "../components/Footer";
import Header from "../components/Header";
import routes from "./config";
import HeroWithVideo from "../components/Hero/HeroWithVideo";
import { Styles } from "../styles/styles";
import { Analytics } from '@vercel/analytics/react';

const Router = () => {
  return (
    <Suspense fallback={null}>
      <Styles />
      <HeroWithVideo
        header={<Header />}
        title="Clinica Iris Guirao"
        text="Fisioterapia, Podología, Psicología y Nutrición en un mismo lugar, para recuperar tu equilibrio y calidad de vida."
        videoSrc="/img/svg/videoIris.mp4"
      />
      <Switch>
        {routes.map((routeItem) => {
          return (
            <Route
              key={routeItem.component}
              path={routeItem.path}
              exact={routeItem.exact}
              component={lazy(() => import(`../pages/${routeItem.component}`))}
            />
          );
        })}
      </Switch>
      <Footer />
      <Analytics />
    </Suspense>
  );
};

export default Router;
